import updateSearchFields from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/UpdateSearchFields";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import searchFilterAccessorials from "@tKgpco/Handlers/Accessorials/SearchFilterAccessorials";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";
import { AccessorialsFormValues } from "@tKgpco/Store/Data/Accessorials/AccessorialsState";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomApplicationState) => ({
    pagination: state.KGPState.customAccessorials.pagination,
    selectFilter: state.KGPState.customAccessorials.selectFilter,
    selectFilterText: state.KGPState.customAccessorials.selectFilterText,
});

const mapDispatchToProps = {
    searchFilterAccessorials,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface AccessorialsPaginationStyles {
    pagination?: PaginationPresentationProps;
}

export const accessorialsPaginationStyles: AccessorialsPaginationStyles = {};

const styles = accessorialsPaginationStyles;

const AccessorialsPagination = ({ searchFilterAccessorials, pagination, selectFilter, selectFilterText }: Props) => {

    if (!pagination) {
        return null;
    }
    const [shouldScrollToTop, setShouldScrollToTop] = useState(false);
    useEffect(() => {
        if (shouldScrollToTop) {
            window.scrollTo(0, 0);
            setShouldScrollToTop(false);
        }
    }, [pagination?.page]);

    const { totalItemCount, page, pageSize, pageSizeOptions, prevPageUri, nextPageUri } = pagination;
    if (totalItemCount === 0) {
        return null;
    }

    const changePage = (newPageIndex: number) => {
        searchFilterAccessorials({ queryParams: { page: newPageIndex, [selectFilter as keyof AccessorialsFormValues]: selectFilterText } });
        setShouldScrollToTop(true);
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.currentTarget.value, 10);
        updateSearchFields({
            page: 1,
            pageSize: newPageSize,
        });
    };

    return (
        <Pagination
            {...styles.pagination}
            resultsCount={totalItemCount}
            currentPage={page}
            resultsPerPage={pageSize}
            resultsPerPageOptions={pageSizeOptions}
            onChangePage={changePage}
            onChangeResultsPerPage={changeResultsPerPage}
            prevPage={prevPageUri}
            nextPage={nextPageUri}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(AccessorialsPagination),
    definition: {
        displayName: "Accessorials Pagination",
        group: "Basic",
    },
};

export default widgetModule;
